import React from "react";
import { useTable } from "../../context/TableContext.js";

export default function Header() {
  const { state, actions } = useTable();

  const canUndo = state.historyIndex > 0;
  const canRedo = state.historyIndex < state.history.length - 1;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-EAECF0">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Title */}
        <h1 className="text-2xl font-semibold text-primary">
          Build Your Invoice
        </h1>

        {/* Actions */}
        <div className="flex items-center gap-2">
          {/* Undo */}
          <button
            type="button"
            onClick={actions.undo}
            disabled={!canUndo}
            title="Undo (Ctrl+Z)"
            data-testid="button-undo"
            className="
              p-2 rounded-md border border-EAECF0
              text-reports-shade3_text
              hover:bg-reports-shade1_bg hover:text-reports-shade1_text
              focus:outline-none focus:ring-2 focus:ring-focus-color
              disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            <i className="fas fa-undo text-sm" aria-hidden="true" />
            <span>Undo</span>
          </button>

          {/* Redo */}
          <button
            type="button"
            onClick={actions.redo}
            disabled={!canRedo}
            title="Redo (Ctrl+Y)"
            data-testid="button-redo"
            className="
              p-2 rounded-md border border-EAECF0
              text-reports-shade3_text
              hover:bg-reports-shade1_bg hover:text-reports-shade1_text
              focus:outline-none focus:ring-2 focus:ring-focus-color
              disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            <i className="fas fa-redo text-sm" aria-hidden="true" />
            <span>Redo</span>
          </button>

          {/* Divider */}
          <span className="mx-2 h-6 w-px bg-EAECF0" />

          {/* Export */}
          <button
            type="button"
            onClick={actions.toggleExportModal}
            data-testid="button-export"
            className="
              inline-flex items-center gap-2 px-4 py-2 rounded-md
              bg-reports-shade6_text text-reports-shade6_bg
              hover:bg-reports-shade6_bg hover:text-reports-shade6_text
              shadow-sm
              focus:outline-none focus:ring-2 focus:ring-focus-color
            "
          >
            <i className="fas fa-download text-sm" aria-hidden="true" />
            <span>Export HTML</span>
          </button>
        </div>
      </div>
    </header>
  );
}
